import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useAtomValue, useSetAtom } from 'jotai'

import * as lib from '../../lib'
import * as state from '../../states'
import { IRevenueAgency } from '../../types'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'
import { NotSystemItems, ModalBodyBox } from '../role'

type IRevenueAgencyRemoveModalBase = {
	item: IRevenueAgency | null;
	show: boolean;
	onClose: () => void;
	onSave: () => void;
}

type IRevenueAgencyRemoveModalProps = IRevenueAgencyRemoveModalBase

const ItemBox = styled.div`
    padding-top: 2px;
`

const IdBox = styled.span`
    display: inline-block;
    min-width: 85px;
`

export const RevenueAgencyRemoveModal = (
	props: IRevenueAgencyRemoveModalProps
) => {
	const { t } = useTranslation()
	const tokens = useAtomValue(state.tokensAtom)
	const access = tokens?.access ?? null
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const { show, onClose, onSave } = props

	const item = props.item

	if (!show) {
		return null
	}
	//console.log('RevenueAgencyRemoveModal: ', {items})
	const onRemove = async () => {
		const uri: string = `revenue/agency/${item?.id}`
		const method: string = 'DELETE'


		const params: lib.FetchOptions['params'] = {}
		const headers = lib.bearer(access)
		const options: lib.FetchOptions = { method, params, headers }

		try {
			setFetchIsLoading(state.turnOnLoader)
			const response = await lib.fetching<void>(uri, options)
			onSave()
			//TODO: check response for each item (true/false) ...?!
			//console.log('onRemove: ', {response})
			if ((response as any)?.result) {
				const resObj = (response as any)?.result ?? {}
				const resEntries = Object.entries(resObj)
				const isSomeError = resEntries?.some(([key, value]) => !value)

				if (isSomeError) {
					throw resObj
				}
			}
		} catch (error: unknown) {
			// TODO: pretty notification alert
			console.error(error)
		} finally {
			setFetchIsLoading(state.turnOffLoader)
		}
	}

	const renderSingleItem = () => {
		const itemLabel = item?.name ? `${item?.name}` : '?'

		return (
			<NotSystemItems>
				<Trans
					i18nKey={ALL_LANG_KEY.revenue_agency_crud_modal.title_remove_single}
					components={{ span: <span className={'text-danger'}/> }}
				/>:
				<br/>
				<br/>
				<ItemBox key={`revenue-agency-${item?.id}`}
					// className={'text-danger'}
				>
					- <IdBox className={'text-danger'}>[id: {item?.id}]</IdBox> {itemLabel}
				</ItemBox>
			</NotSystemItems>
		)
	}

	const modalTitle = (
		<Trans
			i18nKey={ALL_LANG_KEY.revenue_agency_crud_modal.title_remove_single}
			components={{ span: <></> }}
		/>
	)
	const modalBody = (
		<>
			{renderSingleItem()}
		</>
	)
	const msgRemoveConfirm = `${t(ALL_LANG_KEY.revenue_agency_crud_modal.msg_remove_confirm)}`

	return <>
		<Modal show={show} onHide={onClose} className={'scroll'}>
			<Modal.Header closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<ModalBodyBox className={'fs-25'}>
					{modalBody}
					<span className={'text-primary'}>{msgRemoveConfirm}</span>
				</ModalBodyBox>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="primary" onClick={onRemove}>{`${t(ALL_LANG_KEY.revenue_agency_crud_modal.btn_remove)}`}</Button>
				<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.revenue_agency_crud_modal.btn_close)}`}</Button>
			</Modal.Footer>
		</Modal>
	</>
}
